export const paymentStatsStyles = {
  root: {
    display: "flex",
    border: "1px solid rgba(234, 234, 234, 1)",
    borderRadius: "12px",
    backgroundColor: "rgba(255, 255, 255, 1)",
  },

  section: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 16px",
  },

  sectionWithBorder: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 16px",
    borderLeft: "1px solid rgba(234, 234, 234, 1)",
  },

  iconBoxPending: {
    width: "48px",
    height: "48px",
    backgroundColor: "rgba(242, 243, 251, 1)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  iconBoxEarnings: {
    width: "48px",
    height: "48px",
    backgroundColor: "rgba(219, 240, 236, 1)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  textContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },

  titleText: {
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "160%",
  },

  amountText: {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "100%",
  },

  iconWrapper: {
    display: "flex",
  },
};

export const myJobsPageStyles = {
  mainContainerStyles: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    marginTop: { xs: "75px", md: "0px" },
  },

  scrollableContainerStyles: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    flexBasis: 0,
    overflow: { xs: "auto", md: "hidden" },
    minHeight: 0,
  },
};

export const jobsContentStyles = {
  containerStyles: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    flex: 1,
    minHeight: { xs: "auto", md: 0 },
    overflow: { xs: "visible", md: "hidden" },
  },
};

export const pendingRequestsTableStyles = {
  containerStyles: {
    display: "flex",
    flexDirection: "column",
    flex: "0 1 auto",
    maxHeight: "45%",
    minHeight: 0,
    overflow: "auto",
  },

  titleBoxStyles: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    justifyContent: "space-between",
    paddingBottom: "24px",
    backgroundColor: "#f8f7fa",
    position: "sticky",
    top: 0,
    zIndex: 100,
  },

  titleText: {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "24px",
  },
};

export const myJobsCardStyles = {
  tableCellStyles: {
    fontSize: "14px",
    color: "rgba(72, 72, 72, 1)",
    fontWeight: 400,
  },

  requestIdCellStyle: {
    fontSize: "14px",
    color: "rgba(72, 72, 72, 0.9)",
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "max-content",
  },

  actionButtonStyle: {
    padding: "6px 8px !important",
    borderRadius: "4px",
    backgroundColor: "rgba(242, 243, 251, 1)",
    textTransform: "none",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "18px",
    color: "rgba(36, 139, 112, 1)",
    minWidth: "max-content",
  },

  dueDateCellStyle: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    px: "8px",
    borderRadius: "4px",
    width: "max-content",
    height: "26px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};
